import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';

import { switchMap, withLatestFrom } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { Action, select, Store } from '@ngrx/store';
import {
  LoadQuestions,
  QuestionsActionTypes,
  RemoveQuestion,
  UpdateQuestion,
} from '../actions/questions.actions';
import { getQuestionsState } from '../reducers';
import { QuestionState } from '../reducers/questions.reducers';
import { v4 as uuid } from 'uuid';

@Injectable()
export class QuestionsEffects {
  @Effect()
  updateQuestions$: Observable<Action> = this.actions$.pipe(
    ofType<UpdateQuestion>(QuestionsActionTypes.UpdateQuestion),
    withLatestFrom(this.store$.pipe<QuestionState>(select(getQuestionsState))),
    switchMap(([action, state]) => {
      const questions = state.questions;
      const index = state.questions.findIndex(
        item => item.uuid === action.payload.questionToUpdate.uuid
      );
      if (index === -1) {
        questions.push(action.payload.questionToUpdate);
      } else {
        Object.assign(questions[index], {
          ...action.payload.questionToUpdate,
        });
      }
      return of(
        new LoadQuestions({
          step_id: state.step_id,
          step_type: state.step_type,
          questions: questions,
        })
      );
    })
  );

  @Effect()
  removeQuestions$: Observable<Action> = this.actions$.pipe(
    ofType<RemoveQuestion>(QuestionsActionTypes.RemoveQuestion),
    withLatestFrom(this.store$.pipe<QuestionState>(select(getQuestionsState))),
    switchMap(([action, state]) => {
      state.questions.splice(action.payload.index, 1);
      return of(
        new LoadQuestions({
          questions: state.questions,
          step_id: state.step_id,
          step_type: state.step_type,
        })
      );
    })
  );

  constructor(
    private actions$: Actions,
    private store$: Store<QuestionState>
  ) {}
}
